"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _MonthPanel = _interopRequireDefault(require("./view/MonthPanel"));

var _YearPanel = _interopRequireDefault(require("./view/YearPanel"));

var _DecadePanel = _interopRequireDefault(require("./view/DecadePanel"));

var _Header = _interopRequireDefault(require("./view/Header"));

var _standard = _interopRequireDefault(require("./util/standard"));

var _classnames = _interopRequireDefault(require("./util/classnames"));

var _CalendarContext = require("./CalendarContext");

var _useUncontrolled5 = _interopRequireDefault(require("./useUncontrolled"));

var _useCls = _interopRequireDefault(require("./useCls"));

var _excluded = ["now", "value", "defaultValue", "onChange", "rangeValue", "current", "defaultCurrent", "onCurrentChange", "sidebar", "className", "disabledRule", "onModeChange"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Month = function Month(_ref) {
  var now = _ref.now,
      _value = _ref.value,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue,
      _onChange = _ref.onChange,
      rangeValue = _ref.rangeValue,
      _current = _ref.current,
      defaultCurrent = _ref.defaultCurrent,
      _onCurrentChange = _ref.onCurrentChange,
      sidebar = _ref.sidebar,
      className = _ref.className,
      _ref$disabledRule = _ref.disabledRule,
      disabledRule = _ref$disabledRule === void 0 ? {} : _ref$disabledRule,
      onModeChange = _ref.onModeChange,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var d = (0, _react.useMemo)(function () {
    return new Date();
  }, []);

  var _useUncontrolled = (0, _useUncontrolled5.default)(_value, defaultValue, _onChange),
      _useUncontrolled2 = (0, _slicedToArray2.default)(_useUncontrolled, 2),
      value = _useUncontrolled2[0],
      onChange = _useUncontrolled2[1];

  var standardValue = (0, _react.useMemo)(function () {
    return (0, _standard.default)(value);
  }, [value]);
  var standardRangeValue = (0, _react.useMemo)(function () {
    return rangeValue ? [(0, _standard.default)(rangeValue[0]), (0, _standard.default)(rangeValue[1])] : rangeValue;
  }, [rangeValue]);

  var _useUncontrolled3 = (0, _useUncontrolled5.default)(_current, defaultCurrent || value || d, _onCurrentChange),
      _useUncontrolled4 = (0, _slicedToArray2.default)(_useUncontrolled3, 2),
      current = _useUncontrolled4[0],
      onCurrentChange = _useUncontrolled4[1];

  var standardCurrent = (0, _react.useMemo)(function () {
    return (0, _standard.default)(current);
  }, [current]);
  var standardNow = (0, _react.useMemo)(function () {
    return (0, _standard.default)(now === undefined ? d : now);
  }, [d, now]);

  var _useState = (0, _react.useState)('month'),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      mode = _useState2[0],
      setMode = _useState2[1];

  var disabledMonth = disabledRule.month,
      disabledYear = disabledRule.year,
      disabledDecade = disabledRule.decade;
  var handleModeChange = (0, _react.useCallback)(function (mode) {
    onModeChange === null || onModeChange === void 0 ? void 0 : onModeChange(mode);
    setMode(mode);
  }, [onModeChange]);
  var onYearChange = (0, _react.useCallback)(function (current) {
    onCurrentChange(current);
    handleModeChange('month');
  }, [handleModeChange, onCurrentChange]);
  var onDecadeChange = (0, _react.useCallback)(function (current) {
    onCurrentChange(current);
    handleModeChange('year');
  }, [handleModeChange, onCurrentChange]);
  var cls = (0, _useCls.default)();
  var panel = (0, _react.useMemo)(function () {
    var sharedProps = {
      now: standardNow,
      value: standardValue === null ? undefined : standardValue,
      rangeValue: standardRangeValue,
      current: standardCurrent,
      onCurrentChange: onCurrentChange
    };

    switch (mode) {
      case 'month':
        {
          return /*#__PURE__*/_react.default.createElement(_MonthPanel.default, (0, _extends2.default)({
            disabledMonth: disabledMonth,
            onChange: onChange
          }, sharedProps));
        }

      case 'year':
        {
          return /*#__PURE__*/_react.default.createElement(_YearPanel.default, (0, _extends2.default)({
            disabledYear: disabledYear,
            onChange: onYearChange
          }, sharedProps));
        }

      case 'decade':
        {
          return /*#__PURE__*/_react.default.createElement(_DecadePanel.default, (0, _extends2.default)({
            disabledDecade: disabledDecade,
            onChange: onDecadeChange
          }, sharedProps));
        }

      default:
        {
          return null;
        }
    }
  }, [disabledDecade, disabledMonth, disabledYear, mode, onChange, onCurrentChange, onDecadeChange, onYearChange, standardCurrent, standardNow, standardRangeValue, standardValue]);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)(cls.wrap, cls.month, className)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: cls.monthWrap
  }, /*#__PURE__*/_react.default.createElement(_Header.default, {
    value: standardCurrent,
    onChange: onCurrentChange,
    mode: mode,
    onModeChange: handleModeChange
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: cls.body
  }, panel, sidebar)));
};

var _default = (0, _CalendarContext.withContext)( /*#__PURE__*/(0, _react.memo)(Month));

exports.default = _default;